var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 5H.2a.2.2 0 0 0-.2.2v21.6c0 .11.09.2.2.2h31.6a.2.2 0 0 0 .2-.2V5.2a.2.2 0 0 0-.2-.2M2 7.2c0-.11.09-.2.2-.2h27.6c.11 0 .2.09.2.2v3.6a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2zM29.8 25H2.2a.2.2 0 0 1-.2-.2V13.2c0-.11.09-.2.2-.2h27.6c.11 0 .2.09.2.2v11.6a.2.2 0 0 1-.2.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m-11.2 0H5.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h7.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2"
  })));
};
export default SvgCreditCard;